import React, { useState } from "react"

const VideoPlayer = ({ videoUrl, videoTitle }) => {
  const [showVideo, setShowVideo] = useState(false)
  const [hasError, setHasError] = useState(false)

  if (!videoUrl) return null

  // Extract video ID and convert to embed URL
  const getEmbedUrl = (url) => {
    // Handle youtube.com/watch?v=VIDEO_ID
    const watchMatch = url.match(/youtube\.com\/watch\?v=([^&]+)/)
    if (watchMatch) {
      return `https://www.youtube.com/embed/${watchMatch[1]}`
    }

    // Handle youtu.be/VIDEO_ID
    const shortMatch = url.match(/youtu\.be\/([^?]+)/)
    if (shortMatch) {
      return `https://www.youtube.com/embed/${shortMatch[1]}`
    }

    // Handle already-embedded URLs
    if (url.includes("youtube.com/embed/")) {
      return url
    }

    // Handle Vimeo
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/)
    if (vimeoMatch) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}`
    }

    // Return as-is for other providers
    return url
  }

  const embedUrl = getEmbedUrl(videoUrl)

  if (hasError) {
    return (
      <div className="videoContainer">
        <span className="videoLabel">Video Explanation:</span>
        <div className="videoError">
          <p>Video unavailable.</p>
          <a
            href={videoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="videoLink"
          >
            Watch on YouTube
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="videoContainer">
      <span className="videoLabel">Video Explanation:</span>
      {!showVideo ? (
        <button
          className="loadVideoButton"
          onClick={() => setShowVideo(true)}
          aria-label={`Load video: ${videoTitle || "Solution explanation"}`}
        >
          <span className="playIcon">▶</span>
          <span>Load Video Walkthrough</span>
        </button>
      ) : (
        <div className="videoWrapper">
          <iframe
            src={embedUrl}
            title={videoTitle || "Solution explanation video"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="videoFrame"
            onError={() => setHasError(true)}
          />
        </div>
      )}
    </div>
  )
}

export default VideoPlayer
